(function() {

  'strict mode';

  function upToTop() {

    var upToTop = {};

    function link($scope, $element, $attr) {

      if ($attr.upToTop) {
        $("html, body").animate({ scrollTop: 0 }, 500);
      }

    }

    upToTop.restrict = 'A';
    upToTop.link = link;

    return upToTop;

  }

  angular
    .module('mandaeApp')
    .directive('upToTop', upToTop);

}());
